/*
 * Copyright (c) 2024, King Living
 * Shared hex colour normalization for Contentful values.
 * Use from theme (no fallback → undefined) or models (with fallback → always string).
 */

/**
 * Normalize a hex colour string for CSS (trim, ensure leading #).
 *
 * @param {string} [raw] - Raw hex from Contentful (e.g. "fff", "#fff")
 * @param {string} [optionalFallback] - If provided, returned when raw is empty or invalid
 * @returns {string|undefined} Normalized hex, or optionalFallback when given, else undefined
 */
export function normalizeHex(raw, optionalFallback) {
  if (typeof raw !== 'string') return optionalFallback;
  const trimmed = raw.trim();
  if (!trimmed) return optionalFallback;
  const hex = trimmed.startsWith('#') ? trimmed : `#${trimmed}`;
  return hex;
}
